(() => {
  const widgetSelector = '#judgeme_product_reviews';
  const replySelector = '.jdgm-rev__reply-content';
  const collapsedClass = 'jdgm-reply--collapsible';
  const labelsByLanguage = {
    cs: 'Číst dále',
    de: 'Mehr lesen',
    en: 'Read more',
    fr: 'Lire la suite',
    pl: 'Czytaj więcej',
    sk: 'Čítať ďalej',
  };

  let replyId = 0;
  let scanFrame;

  const getLabel = () => {
    const language = document.documentElement.lang.toLowerCase().split('-')[0];
    return labelsByLanguage[language] || labelsByLanguage.en;
  };

  const createLink = (reply) => {
    const link = document.createElement('a');

    replyId += 1;
    reply.id ||= `judgeme-reply-${replyId}`;
    link.className = 'jdgm-reply-toggle';
    link.href = `#${reply.id}`;
    link.textContent = getLabel();

    reply.insertAdjacentElement('afterend', link);
  };

  const prepareReply = (reply) => {
    if (reply.dataset.replyToggleReady === 'true') return;

    const naturalHeight = reply.scrollHeight;
    const styles = window.getComputedStyle(reply);
    const computedLineHeight = parseFloat(styles.lineHeight);
    const fontSize = parseFloat(styles.fontSize);
    const lineHeight = Number.isFinite(computedLineHeight) ? computedLineHeight : fontSize * 1.4;

    // Judge.me can insert replies before their final layout is available.
    if (!naturalHeight || !Number.isFinite(lineHeight)) return;

    reply.dataset.replyToggleReady = 'true';

    if (naturalHeight <= lineHeight * 3 + 1) return;

    reply.classList.add(collapsedClass);
    createLink(reply);
  };

  const scanReplies = (widget) => {
    widget.querySelectorAll(replySelector).forEach(prepareReply);
  };

  const scheduleScan = (widget) => {
    window.cancelAnimationFrame(scanFrame);
    scanFrame = window.requestAnimationFrame(() => scanReplies(widget));
  };

  const initialize = () => {
    const widget = document.querySelector(widgetSelector);
    if (!widget) return;

    scheduleScan(widget);

    const observer = new MutationObserver(() => scheduleScan(widget));
    observer.observe(widget, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
